export default __webpack_public_path__ + "static/media/Guardsquare.75939da1.svg";